import { pluralTypeToId, toObjectTypes } from 'in-meeting-experience-ui-components/constants/types';
import { getInMeetingExperienceProxyApiUrl, getProxyApiUrl } from 'in-meeting-experience-ui-components/utils/general';
import { DEBOUNCE_TIME } from '../../constants/Http';
import { meetingCardProperties } from '../../constants/apiResponses';
import noAuthClient from '../../utils/apiClient';
const API_BASE = getProxyApiUrl();
const API_PROXY_BASE = getInMeetingExperienceProxyApiUrl();
export const fetchCardProperties = ({
  objectType
}) => objectType === toObjectTypes.meeting ? Promise.resolve(meetingCardProperties) : noAuthClient.get(`${API_PROXY_BASE}/v1/cards/properties/${objectType}`);
export const fetchPropertiesDetails = ({
  objectType,
  data
}) => noAuthClient.post(`${API_BASE}/crm/v3/properties/${objectType}/batch/read`, {
  data
});
export const fetchObjectCreationFields = objectTypeId => noAuthClient.get(`${API_PROXY_BASE}/v1/fields/${objectTypeId}/creator`);
export const fetchExternalOptions = ({
  query = '',
  referenceType,
  offset = 0,
  limit = 25,
  typeId = pluralTypeToId.contacts,
  delay
}) => noAuthClient.get(`${API_PROXY_BASE}/v1/object-properties/external-options/${typeId}/${referenceType}/paged?limit=${limit}&offset=${offset}&searchQuery=${query}`, Object.assign({}, delay && {
  delay
}));
export const validateProperty = ({
  crmObjectType,
  data
}) => noAuthClient.post(`${API_PROXY_BASE}/v1/property-validation/${crmObjectType.toUpperCase()}/extended?customValidation=true`, {
  data,
  delay: DEBOUNCE_TIME
});